import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AuthenticationState } from './types';
import { RootState } from '@/types';

export const state: AuthenticationState = {
    jwt: undefined,
    user: undefined,
    error: false,
};

const namespaced: boolean = true;

export const authentication: Module<AuthenticationState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
